export enum ChatBaseDataAction {
  INIT = 'chatBaseData/INIT'
}
